import { useTexts } from 'utils/useTexts';
import useEffectOnce from '@shared/hooks/useEffectOnce';
import { useAnalytics } from '@shared/hooks/useAnalytics';
import { useAnalyticsContext } from '@context/analyticsContext';
import { DisqualifiedList } from './DisqualifiedList';


const Disqualified = () => {
  const { t } = useTexts();
  const {analyticsState} = useAnalyticsContext();
  const { trackClick, trackPage } = useAnalytics({
    flow_step :analyticsState?.parameters?.flow_step,
    flow_stage: analyticsState?.parameters?.flow_stage,
  });
  
  useEffectOnce(() => trackPage(t('pageTitles.Disqualified')));

  const handlePhoneNumberClick = () => {
    trackClick('CTA Clicked', {
      cta_text: 'Call'+t('contactPhoneNumber'),
      cta_type: 'phone',
      cta_context: 'off-ramp',
      interaction_type: 'cta_click',
      destination_url: 'tel:'+t('contactPhoneNumber'),
      value: 75,
      currency: 'USD',
    });
  };

  return (
    <div className="iLendingCDX-disqualified-container">
      <h1 className="iLendingCDX-form-title">{t('disqualified.title')}</h1>
      <p>{t('disqualified.startText')}</p>
      <DisqualifiedList />
      <p>
        {t('disqualified.endText')}
        <a
          href={'tel:' + t('contactPhoneNumber').replace(/-/g, '')}
          onClick={handlePhoneNumberClick}
        >
          {t('contactPhoneNumber')}
        </a>
        .
      </p>
    </div>
  );
};

export default Disqualified;
